<div id="dragDiv"
     #draggableDiv
     class="draggable resize overlay-borde-formulario"
     [ngStyle]="boxStyle">
  <svg #draggableIcon class="icon-draggable">
    <use xlink:href="#icon-draggable"></use>
  </svg>
  <svg *ngIf="!modoEnvioSimple" class="icon-editar" (click)="editarInfoCasilla()">
    <use xlink:href="#hs-edit-key"></use>
  </svg>
  <svg class="icon-close" (click)="borrarCasilla()">
    <use xlink:href="#icon-close"></use>
  </svg>
  <div id="resizeDiv" class="pinta"></div>
</div>
